import { ArrowLink } from "@features/atoms/ArrowLink"
import { Chip } from "@features/atoms/Chip"
import { PageIntro } from "@features/content/PageIntro"
import { defineBlock, EditableText, usePostExcerptEditor, usePostMetaEditor, usePostTitleEditor } from "eddev/blocks"
import { Link } from "eddev/routing"
import { adminMessage } from "../../styles/helper-styles"

export const meta: BlockMeta = {
  title: "Blog post Intro",
  icon: "edit-page",
  postMetaBlock: {
    postTypes: ["blog"],
    fieldName: "info",
  },
  flags: {
    selfAnimates: true,
  },
}

export default defineBlock("blog/blog-post-intro", (props) => {
  return (
    <div className="mb-12">
      <PageIntro
        layoutKey={"blog-" + props.blogPost?.slug}
        eyebrow={
          <div className="flex gap-3 items-center">
            <Link href="/blog/">
              <ArrowLink type="left">
                <span>Insights</span>
              </ArrowLink>
            </Link>
            {!props.category?.length && env.admin && <div className={adminMessage()}>No category</div>}
            {props.category?.map((category) => <Chip key={category?.slug}>{category?.name}</Chip>)}
          </div>
        }
        title={
          <EditableText
            as="p"
            store={usePostTitleEditor(props.blogPost?.title!)}
            placeholder="Post Title"
            plainText
            disableLineBreaks
          />
        }
        description={
          <EditableText
            as="div"
            store={usePostExcerptEditor(props.blogPost?.excerpt!)}
            placeholder="Enter a short description here"
            plainText
            disableLineBreaks
            className="type-label-l text-white/60"
          />
        }
        spacingTop="page"
      />
    </div>
  )
})
